import { render, staticRenderFns } from "./BaixarMensalidadePage.vue?vue&type=template&id=ba69dcc2"
import script from "./BaixarMensalidadePage.vue?vue&type=script&lang=js"
export * from "./BaixarMensalidadePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports